<script>
export default {
    name: 'IconWebcam'
}
</script>
<template>
    <svg
        class="base-icon icon-webcam"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M32 12c11.046 0 20 8.954 20 20a19.937 19.937 0 01-5.858 14.142L56 56h-8l-6.242-6.538a19.865 19.865 0 01-6.757 2.314L35 56h-6v-4.223a19.865 19.865 0 01-6.757-2.315L16 56H8l9.859-9.857A19.937 19.937 0 0112 32c0-11.046 8.954-20 20-20zm0 6c-7.732 0-14 6.268-14 14s6.268 14 14 14 14-6.268 14-14-6.268-14-14-14zm0 6a8 8 0 110 16 8 8 0 010-16z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
